import { cva } from "class-variance-authority";

export const emptyStateVariants = cva(
  "h-full min-h-0 w-full flex-1 self-stretch items-center justify-center rounded-none text-center wrap-anywhere",
  {
    variants: {
      layout: {
        inline: "gap-2 px-4 py-4",
        collection: "px-6 py-6",
        panel: "px-6 py-8",
        workspace: "px-6 py-8",
      },
    },
    defaultVariants: { layout: "panel" },
  },
);
